module.exports = __webpack_public_path__ + "media/images/icons/SVG/030-9281914c04f32f4b5253df1747a18d7d.svg";